import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { EdpSavingsComponent } from "./edp-savings.component";
import { EdpPipesModule } from "src/app/@pipes/edp-pipes.module";

@NgModule({
    declarations: [EdpSavingsComponent],
    imports: [CommonModule, TranslateModule, EdpPipesModule],
    exports: [EdpSavingsComponent],
})
export class EdpSavingsModule {}
